import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, can } from "@/auth";
import { Loading } from "@/components/Bits";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (role && !can(user, role)) return <Navigate to="/" replace />;
  return children;
}
